import {
  isEntityServerSideFiltered,
  isEntityServerSidePaginated,
  type RydeUiUnit,
} from "@ryde/shared";

/** Server-filtered grids reset the page in their refetch; the rest narrow in the browser with no fetch. */
export const shouldResetPageOnFiltersChange = (entity: RydeUiUnit): boolean =>
  !isEntityServerSideFiltered(entity);

/** Server-paged grids search on Apply, whose refetch resets the page; the rest search in the browser. */
export const shouldResetPageOnSearchChange = (entity: RydeUiUnit): boolean =>
  !isEntityServerSidePaginated(entity);

/** Clear-all drops filters and search together, so it resets wherever either one narrows in the browser. */
export const shouldResetPageOnClearAll = (entity: RydeUiUnit): boolean =>
  shouldResetPageOnFiltersChange(entity) ||
  shouldResetPageOnSearchChange(entity);
